<template>
  <div class="tixstock-header">
    <div class="tixstock-nav pl-10 pt-10">
      <div v-for="(main, mainIndex) in menu" :key="main._id" class="tixstock-nav-item"
        :class="{ active: activeMain === mainIndex }" @mouseenter="onMainEnter(mainIndex)" @mouseleave="resetMenu">
        <!-- MAIN TITLE (ONLY THIS IS CLICKABLE) -->
        <span class="tixstock-nav-title" @click.stop="goToCategory(main)">
          {{ main.displayName ? main.displayName : main.name }}
        </span>

        <!-- MEGA DROPDOWN -->
        <div v-if="activeMain === mainIndex && main.children && main.children.length" class="tixstock-mega-dropdown"
          @click.stop>
          <!-- LEVEL 1 -->
          <ul class="tixstock-mega-level">
            <li v-for="item in main.children" :key="item._id" class="tixstock-mega-level-item"
              :class="{ active: activeLevel1 === item }" @mouseenter="onLevel1Enter(item)"
              @click.stop="goToCategory(item)">
              <span>{{ item.displayName ? item.displayName : item.name }}</span>
              <span v-if="item.children && item.children.length" class="tixstock-mega-arrow">
                ›
              </span>
            </li>
          </ul>

          <!-- LEVEL 2 -->
          <div v-if="activeLevel2.length" class="tixstock-mega-level">
            <ul>
              <li v-for="child in activeLevel2" :key="child._id" class="tixstock-mega-level-item"
                :class="{ active: activeLevel2Item === child }" @mouseenter="onLevel2Enter(child)"
                @click.stop="goToCategory(child)">
                <span>
                  {{ child.displayName ? child.displayName : child.name }}
                </span>
                <span v-if="child.children && child.children.length" class="tixstock-mega-arrow">
                  ›
                </span>
              </li>
            </ul>
          </div>

          <!-- LEVEL 3 -->
          <div v-if="activeLevel3.length" class="tixstock-mega-level">
            <ul>
              <li v-for="grand in activeLevel3" :key="grand._id" class="tixstock-mega-level-item"
                @click.stop="goToCategory(grand)">
                {{ grand.displayName ? grand.displayName : grand.name }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "TixstockHeader",

  data() {
    return {
      activeMain: null,
      activeLevel1: null,
      activeLevel2: [],
      activeLevel2Item: null,
      activeLevel3: []
    };
  },

  computed: {
    ...mapGetters({
      menu: "tixstockNavcategories"
    })
  },

  methods: {
    onMainEnter(index) {
      this.activeMain = index;
    },

    onLevel1Enter(item) {
      this.activeLevel1 = item;
      this.activeLevel2 = item.children || [];
      this.activeLevel2Item = null;
      this.activeLevel3 = [];
    },

    onLevel2Enter(child) {
      this.activeLevel2Item = child;
      this.activeLevel3 = child.children || [];
    },

    resetMenu() {
      this.activeMain = null;
      this.activeLevel1 = null;
      this.activeLevel2 = [];
      this.activeLevel2Item = null;
      this.activeLevel3 = [];
    },

    goToCategory(category) {
      if (!category || !category.slug) return;

      this.resetMenu();
      this.$router.push(`/international/event/${category._id}`);
    }
  }
};
</script>

<style scoped>
.tixstock-header {
  background: #fff;
}

.tixstock-nav {
  display: flex;
  gap: 32px;
  padding: 0 24px;
  position: relative;
}

.tixstock-nav-item {
  position: relative;
  padding: 16px 0;
}

.tixstock-nav-item.active .tixstock-nav-title::after {
  content: "";
  position: absolute;
  bottom: -12px;
  left: 2px;
  width: calc(100% - 4px);
  height: 4px;
  background: #000;
}

.tixstock-nav-title {
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  position: relative;
}

.tixstock-mega-dropdown {
  position: absolute;
  top: 52px;
  left: 0;
  display: flex;
  background: #fff;
  box-shadow: 0 3px 6px #cbcbcb;
  z-index: 1000;
  border-radius: 10px;
}

.tixstock-mega-level {
  width: 240px;
  list-style: none;
  padding: 8px 0;
  border-right: 1px solid #f0f0f0;
}

.tixstock-mega-level:last-child {
  border-right: none;
}

.tixstock-mega-level-item {
  padding: 10px 16px;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  cursor: pointer;
}

.tixstock-mega-level-item:hover,
.tixstock-mega-level-item.active {
  background: #f6f6f6;
}

.tixstock-mega-arrow {
  color: #999;
  font-size: 18px;
}
</style>
